import React from "react";

import { FormattedMessage } from "react-intl";

import * as S from "./CommitList.styles";
import CommitListItem from "./CommitListItem";

type CommitListProps = {
  commits: {
    sha: string;
    message: string;
    author: { name: string; date: number };
  }[];
  isOpen: boolean;
  close: () => void;
};

const CommitList = ({ commits, isOpen, close }: CommitListProps) => {
  if (!commits || !isOpen) return null;

  return (
    <S.CommitListLayout>
      {commits.map(commit => (
        <CommitListItem
          key={commit.sha}
          sha={commit.sha}
          message={commit.message}
          name={commit.author ? commit.author.name : ""}
          date={commit.author ? commit.author.date : 0}
        />
      ))}
      <S.HideLayout>
        <S.ToggleCommits onClick={close}>
          <FormattedMessage id="hide_commits" />
        </S.ToggleCommits>
      </S.HideLayout>
    </S.CommitListLayout>
  );
};

export default CommitList;
